/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Kind_CatalogInputs */

const cs_templates_kind_catalog = /** @type {(inputs: Templates_Kind_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katalog nemovitosti`)
};

const en_templates_kind_catalog = /** @type {(inputs: Templates_Kind_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property catalog`)
};

/**
* | output |
* | --- |
* | "Property catalog" |
*
* @param {Templates_Kind_CatalogInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_kind_catalog = /** @type {((inputs?: Templates_Kind_CatalogInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Kind_CatalogInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_kind_catalog(inputs)
	return cs_templates_kind_catalog(inputs)
});